import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {EventEmitter, Injectable} from "@angular/core";
import {DynamicFormConfig, DynamicFormReadyEvent, FilterSelectFieldConfig, SelectItem} from "@mydocma/dynamic-form";
import {DocumentType} from "@docma-mm-core/document-type/document-type";
import {AttachmentData} from "@docma-mm-core/attachment/attachment";
import {MmProjectLoaderService} from "../../mm-project/mm-project-loader.service";
import {BehaviorSubject, firstValueFrom, map, Observable} from "rxjs";
import {filter} from "rxjs/operators";
import {LoadStatusEnum} from "@docma-mm-core/model/load-state/load-state.enum";
import {addAttachmentFormConfig, commentConfig, descriptionConfig, typeConfig} from "./mm-add-attachments-form.config";

@UntilDestroy()
@Injectable()
export class MmAddAttachmentsFormService {

  onFormReady = new EventEmitter();
  formConfig$ = new BehaviorSubject<DynamicFormConfig>(null);

  private formReadyEvent: DynamicFormReadyEvent;
  private documentTypesLoaded: DocumentType[] = [];

  attachment: AttachmentData;

  documentTypes$: Observable<SelectItem[]> = this.projectLoaderService.documentTypes.pipe(
    filter(m => m?.loadState?.status === LoadStatusEnum.Loaded),
    map(m => m.data.map(c => ({ id: c.Id, text: c.Name1 + (c.Name2 ? ' - ' + c.Name2 : ''), data: c }))),
    untilDestroyed(this));



  constructor(private readonly projectLoaderService: MmProjectLoaderService) {
    this.formConfig$.next(addAttachmentFormConfig);
  }

  onReady(event: DynamicFormReadyEvent) {
    this.formReadyEvent = event;
    this.initialize();
    this.onFormReady.emit();
  }

  async initialize() {
    let typeFieldConfig: FilterSelectFieldConfig = {...typeConfig};
    typeFieldConfig.source = await firstValueFrom(this.documentTypes$);
    this.formReadyEvent.dynamicFormService.updateFieldConfig(typeFieldConfig);
  }

  async loadAttachment(attachment: AttachmentData) {
    this.attachment = attachment ?? new AttachmentData();

    // CURRENTLY ONLY NEW ATTACHMENTS IMPLEMENTED!!
  }

  getChanges() {
    if (!this.attachment) {
      this.attachment = new AttachmentData();
    }

    if (!this.formReadyEvent?.dynamicFormService) {
      return this.attachment;
    }

    this.attachment.Description = this.formReadyEvent.dynamicFormService.getFieldValue(descriptionConfig.name);
    this.attachment.Comment = this.formReadyEvent.dynamicFormService.getFieldValue(commentConfig.name);

    const typeValue = this.formReadyEvent.dynamicFormService.getFieldValue(typeConfig.name);

    if (typeValue) {
      const typeFieldConfig = this.formReadyEvent.dynamicFormService.getFieldConfig(typeConfig.name) as FilterSelectFieldConfig;
      const documentType = typeFieldConfig.source.find(x => x.id === typeValue).data as DocumentType;
      this.attachment.DocumentType = documentType;
    }
    else {
      this.attachment.DocumentType = null;
    }

    return this.attachment;
  }

}
